import {Component, Input, OnInit} from '@angular/core';
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { Metadata } from "../../../model/Metadata";
import { Model } from "../../../model/Model";
import { Language } from "../../../model/Language";
import { FileuploadService } from "../../../service/http/fileupload.service";
import {Router} from "@angular/router";
import {Package} from "../../../model/Package";
import {environment} from "../../../../environments/environment";
import {MatStepper} from "@angular/material";

@Component({
  selector: 'app-workflow-metadata',
  templateUrl: './workflow-metadata.component.html',
  styleUrls: ['./workflow-metadata.component.css']
})
export class WorkflowMetadataComponent implements OnInit {

  cartypes: Model[] = [
    {name: 'Continental GT', code: "634"},
    {name: 'Continental Cabrio', code: "635"},
    {name: 'Continental Saloon', code: "631"},
    {name: 'Bentayga', code: "636"},
    {name: 'Mulsanne', code: "731"},
    {name: 'Electric vehicle', code: "0"}
  ];

  modelYears = ['2018'];

  langs: Language[] = [
      {name: 'English (GB)', icu: 'en_GB',code: 20},
      {name: 'German (DE)', icu: 'de_DE',code: 10},
      {name: 'English (US)', icu: 'en_US',code: 21},
      {name: 'Chinese (CN)', icu: 'zh_CN',code: 93}
  ];

  identifierPattern = "^B\\d{5}$";
  posPattern = "^\\d{4}W\\d{2}$";

  identifierFormControl = new FormControl('', [
    Validators.pattern(this.identifierPattern),
    Validators.required
  ]);
  posFormControl = new FormControl('', [
    Validators.required
  ]);
  modelYearFormControl = new FormControl('', [
    Validators.required
  ]);
  cartypeFormControl = new FormControl('', [
    Validators.required
  ]);
  languageFormControl = new FormControl('', [
    Validators.required
  ]);
  infoFormControl = new FormControl('', [
    Validators.maxLength(250)
  ]);

  public metadataFormGroup = new FormGroup({
      // packageName: this.packageNameFormControl,
      identifier: this.identifierFormControl,
      pos: this.posFormControl,
      modelYear: this.modelYearFormControl,
      cartype: this.cartypeFormControl,
      language: this.languageFormControl,
      info: this.infoFormControl});

  metadata: Metadata;

  identifier = '';
  pos = '';
  cartype = '';
  language = '';
  info = '';

  currentPackageId = '';

  constructor(private uploadService: FileuploadService,
              private _router: Router) {
  }

  ngOnInit() {

    this.modelYears.pop();
    for(var i = 1; i <= 10; i++) {
        let year = 2017;
        year = year + i;
        this.modelYears.push('' + year);
    }

    this.uploadService.getLanguages().subscribe(data => {
      this.langs = data;
    });

    // change naming -> modelCode to code
    this.uploadService.getModels().subscribe(data => {
      this.cartypes = data;
    });

    this.currentPackageId = sessionStorage.getItem('currentPackageId');

    if(this.currentPackageId !== null) {

      this.uploadService.getMetadata(this.currentPackageId).subscribe(data => {

        this.metadataFormGroup.setValue({
          identifier: data["identifier"],
          pos: data["pos"],
          modelYear: data["modelYear"],
          cartype: data["model"]["code"],
          language: +data["language"]["code"],
          info: data["info"]
        });

      });
    }
  }

  sendMetaData() {

    if(this.metadataFormGroup.valid) {

      let modelCode = this.metadataFormGroup.get('cartype').value;
      let model: Model = this.cartypes.filter((entry) => entry.code = modelCode).shift();

      let langCode = this.metadataFormGroup.get('language').value;
      let language: Language = this.langs.filter((entry) => entry.code = langCode).shift();

      this.metadata = new Metadata(
        this.metadataFormGroup.get('identifier').value,
        this.metadataFormGroup.get('pos').value,
        this.metadataFormGroup.get('modelYear').value,
        model,
        language,
        this.metadataFormGroup.get('info').value);

      let currentPackageId = '';
      if(this.currentPackageId !== null) {
        currentPackageId = this.currentPackageId;
      }

      console.log(this.metadata);
      this.uploadService.uploadMetadata(this.metadata, currentPackageId).subscribe(data => {

        this.currentPackageId = sessionStorage.getItem('currentPackageId');

        if(this.currentPackageId === null) {
          sessionStorage.setItem('currentPackageId', data["id"]);
          this.currentPackageId = data["id"];
          this.uploadService.setCurrentPackageId(data["id"]);
        }
      });
    }
  }
}
